import { render, staticRenderFns } from "./SongWaveSurfer.vue?vue&type=template&id=d60a69ee"
import script from "./SongWaveSurfer.vue?vue&type=script&lang=js"
export * from "./SongWaveSurfer.vue?vue&type=script&lang=js"
import style0 from "./SongWaveSurfer.vue?vue&type=style&index=0&id=d60a69ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Viberary/repos/viberary-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports